const initState='';

const SidebarActiveTab = (state = initState, action) => {
    switch(action.type) {
        case  'MainTabContentActiveTab' : return  action.payload;
        default: return state;
    }
}
export default SidebarActiveTab;